import { Text, TextProps } from "@chakra-ui/react";

const EventDetailTitle = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  props?: TextProps;
}) => {
  return (
    <Text fontSize="xl" fontWeight={"bold"} {...props}>
      {children}
    </Text>
  );
};

export default EventDetailTitle;
